import axios from "axios";
import {createUrlParams} from "../utils/urlParams";


export const getMicroZones= async (data) => {
    const urlParams = createUrlParams(data)
    const url = `/api/v1/micro_zones?${urlParams.toString()}`;

    const res = await axios.get(url);
    return res.data;
}